import {IContractShort} from './interface/contract-short.model.interface';
import {Serializable} from '../interface/serializable.interface';

export abstract class ContractShort implements Serializable {
  private readonly _id: number;
  private readonly _number: string;
  private readonly _coreId: number

  protected constructor(instance: IContractShort) {
    this._id = instance.id;
    this._number = instance.number;
    this._coreId = instance.coreId;
  }

  get id(): number {
    return this._id;
  }

  get number(): string {
    return this._number;
  }

  get coreId(): number {
    return this._coreId;
  }

  toHTML(): string {
    return this._number;
  }

  toText(): string {
    return this._number;
  }
}
